import DialogBox from './DialogBox.container';

export default DialogBox;
